import { QueryKeys } from '../../../queryDefaults/QueryKeys';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { AppMedError } from '../../../error/AppMedError.ts';
import { HealthcareFacility, IHealthcareFacility, IHealthcareFacilityPayload } from '../HealthcareFacility.ts';
import { HealthcareFacilitiesApi } from '../../../apis/HealthcareFacilitiesApi/HealthcareFacilitiesApi.ts';

export function usePostHealthcareFacility() {
    const queryClient = useQueryClient();

    return useMutation<IHealthcareFacility, AppMedError, IHealthcareFacilityPayload>({
        mutationKey: [QueryKeys.healthcareFacility, QueryKeys.healthcareFacilities],
        mutationFn: async (variables: IHealthcareFacilityPayload) => {
            const id = await HealthcareFacilitiesApi.postHealthcareFacility(variables);
            const facility = new HealthcareFacility(variables as HealthcareFacility);
            return {
                ...facility,
                id,
            };
        },
        onSuccess: async (data: IHealthcareFacility) => {
            const facilityData: IHealthcareFacility = { ...data };

            queryClient.setQueryData<IHealthcareFacility>([QueryKeys.healthcareFacility], facilityData);

            queryClient.setQueryData<IHealthcareFacility[]>([QueryKeys.healthcareFacilities], (prev) => {
                return prev ? [...prev, facilityData] : [facilityData];
            });
        },
    });
}
